import type { ReactNode } from 'react';

interface ModalProviderProps {
  children: ReactNode;
}

/**
 * Modal Provider — derzeit ohne eigene Modale.
 *
 * Hier hing bis zum 08.09.2026 das E-Mail-Schreibfenster. Es liess sich
 * schon vorher durch nichts mehr oeffnen (`useEmailModal` hatte keinen
 * Aufrufer) und ist mit der Postfachverwaltung entfallen. Der Provider
 * bleibt als Einhaengepunkt fuer das naechste geteilte Modal stehen.
 */
export function ModalProvider({ children }: ModalProviderProps) {
  return <>{children}</>;
}
